export default __webpack_public_path__ + "static/media/house_six.0d7199a4.jpg";